
export default {
    sections: ['details'],
    toolbar: ['add', 'edit', 'active', 'delete'],
    fields: {
        name: {
            section: 'details',
            position: 1,
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.news_category.js